// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".configuration-popup_7142 {\n  width: 75rem;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/Operate/Configuration/ConfigurationPopup.scss","ConfigurationPopup.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;ACCJ","file":"ConfigurationPopup.scss","sourcesContent":[".configuration-popup {\n    width: 75rem;\n}\n",".configuration-popup {\n  width: 75rem;\n}"]}]);
// Exports
exports.locals = {
	"configuration-popup": "configuration-popup_7142"
};
module.exports = exports;
